export enum CaseEvent {
  MODIFY = "modify-case",
}

export enum CaseUpdateEventType {
  caseStarted = "caseStarted",
  age = "age",
  gender = "gender",
  complaint = "complaint",
  tag = "tag",
  dataEnabledTag = "dataEnabledTag",
  chat = "chat",
  chatMessage = "chatmessage",
  hospital = "hospital",
  photo = "photo",
  id = "id",
  ekg = "ekg",
  video = "video",
  voiceMemo = "voicememo",
  liveConsult = "liveconsult",
  monitor = "monitor",
  patientInfo = "patientInfo",
}
